import { YOUR_PERSONAL_DETAILS, MARKETING_PREFERENCES, REVIEW_YOUR_DETAILS } from 'constants/paths';
import {
  PRE_ASSESSED_JOURNEY,
  CONGRATS_REFERRER,
  EMPLOYMENT_REFERRER,
  EXISTING_JOURNEY,
  SOLE_TYPE,
  JOINT_TYPE
} from 'constants/general';
import {
  redirectToOriginApplication,
  redirectCustomerDetails,
  navigateToScreen
} from 'actionCreators/navigation';
import { NATIVE_ACCOUNTS_URL, BROCHUREWARE_URL } from 'constants/externalUrls';
import { getDeviceContext } from 'utils/deviceContext';
import { sendScreenDetailsToMobile } from 'utils/mobileUtils';

function buildParams(params) {
  return Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
}

function getReferrer(journey) {
  switch (journey) {
    case EXISTING_JOURNEY: {
      return 'RLD'; // Review Load Details
    }
    case PRE_ASSESSED_JOURNEY: {
      return CONGRATS_REFERRER;
    }
    default: {
      return 'MBA'; // Main Bank Account
    }
  }
}

const redirectMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case redirectToOriginApplication.toString(): {
      const state = store.getState();
      const { config } = state;

      const DYB_BRAND = 'DYB';
      const {
        origin,
        configUrls: { internetBankingUrl },
        originBrandId,
        sourceId,
        nativeAppData
      } = config;

      const isNative = nativeAppData ? nativeAppData.isNative : false;

      const source_id = isNative ? 'APP' : sourceId;

      if (isNative) {
        window.location = NATIVE_ACCOUNTS_URL;
      } else if (origin && origin.toUpperCase() === 'IB') {
        const param = {
          user_tracking_id: config.userTrackingId,
          access_token: config.accessToken,
          token_type: 'bearer',
          scope: 30,
          ...(source_id && { source_id })
        };
        //brandId is recieving as DYB and url working with brand B
        const url = `${internetBankingUrl}/${
          originBrandId.toUpperCase() === DYB_BRAND ? 'b' : originBrandId
        }#${buildParams(param)}`;

        window.location = url;
      } else {
        window.location = BROCHUREWARE_URL;
      }
      break;
    }
    case redirectCustomerDetails.toString(): {
      const state = store.getState();
      const { config } = state;

      const { loanValues, caseDetails, form } = state;
      const { bankId, brandId, isJoint, jointLinkCode, sourceId } = config;
      const { amount, term, repaymentDay, eligibilityTime } = loanValues;
      const { isNative } = getDeviceContext();
      const source_id = isNative ? 'APP' : sourceId;

      if (!config.testCustomerDetails) {
        let redirectPath;
        switch (action.payload) {
          case 'create': {
            redirectPath = YOUR_PERSONAL_DETAILS;
            break;
          }
          case MARKETING_PREFERENCES: {
            redirectPath = MARKETING_PREFERENCES;
            break;
          }
          case 'review': {
            redirectPath = REVIEW_YOUR_DETAILS;
            break;
          }
          default:
            break;
        }

        const {
          config,
          config: { accessToken },
          exitModalOpen,
          navigation
        } = store.getState();

        sendScreenDetailsToMobile(accessToken, redirectPath, config, exitModalOpen, navigation);

        redirectPath && store.dispatch(navigateToScreen(redirectPath));
      } else {
        if (action.payload === 'create') {
          const reEntryParam = {
            bankId,
            ...(!jointLinkCode && {
              amount,
              term,
              purpose: form.LoanOptionsForm && form.LoanOptionsForm.values.loanPurpose
            }),
            upiTS: new Date().toISOString(),
            eligibilityTS: eligibilityTime,
            day: repaymentDay,
            referrer: 'NCC', //referrer to identify the screen after CD. i.e NCC - new to bank Change of Circumstances
            brandId,
            type: 'external',
            loanType: isJoint ? JOINT_TYPE : SOLE_TYPE,
            debtConsolidate:
              form && form.LoanOptionsForm ? form.LoanOptionsForm.values.debtConsolidation : '',
            amountConsolidate:
              form && form.DebtConsolidationForm
                ? form.DebtConsolidationForm.values.amountConsolidation
                : '',
            ...(jointLinkCode && { jointLinkCode }),
            ...(source_id && { source_id })
          };

          const returnUrl = `${window.location.origin}#${buildParams(reEntryParam)}`;

          const param = {
            bank_id: config.bankId,
            brand_id: config.brandId,
            show: 'PD,AD,CD,ED,ID',
            user_tracking_id: config.userTrackingId,
            layout: 'page',
            redirect_uri: encodeURIComponent(returnUrl)
          };

          const url = `${config.configUrls.customerDetailsUrl}/#${buildParams(param)}`;

          window.location = url;
        } else if (action.payload === MARKETING_PREFERENCES) {
          const reEntryParam = {
            bankId: config.bankId,
            referrer: getReferrer(config.journey),
            brandId: config.brandId,
            customer_uuid: config.customerId,
            caseId: caseDetails.caseId,
            ...(source_id && { source_id })
          };

          const returnUrl = `${window.location.origin}#${buildParams(reEntryParam)}`;

          const param = {
            bank_id: config.bankId,
            brand_id: config.brandId,
            access_token: config.accessToken,
            show: 'MC',
            user_tracking_id: config.userTrackingId,
            redirect_uri: encodeURIComponent(returnUrl)
          };

          const url = `${config.configUrls.customerDetailsUrl}/#${buildParams(param)}`;

          window.location = url;
        } else if (action.payload === 'review') {
          const reEntryParam = {
            bankId: config.bankId,
            referrer: config.journey === EXISTING_JOURNEY ? EMPLOYMENT_REFERRER : 'RLD', //referrer to identify the screen after CD. i.e RLD - Review Loan Details
            brandId: config.brandId,
            customer_uuid: config.customerId,
            caseId: caseDetails.caseId,
            ...(source_id && { source_id })
          };

          const returnUrl = `${window.location.origin}#${buildParams(reEntryParam)}`;

          const param = {
            bank_id: config.bankId,
            brand_id: config.brandId,
            access_token: config.accessToken,
            user_tracking_id: config.userTrackingId,
            redirect_uri: encodeURIComponent(returnUrl)
          };

          if (config.journey !== EXISTING_JOURNEY) {
            param.show = 'PD,AD,CD,ED,ID';
          } else {
            param.expand = 'ID';
          }

          const url = `${config.configUrls.customerDetailsUrl}/#${buildParams(param)}`;

          window.location = url;
        }
      }
      break;
    }
    default:
      break;
  }

  return next(action);
};

export { redirectMiddleware };
